import { getDatesByPattern } from './getDatesByPattern.main';

export { getDatesByPattern };
